export default __webpack_public_path__ + "static/media/arrow-rotate-right-solid-disable.3f71f4f6.svg";